<template>
  <v-btn
    v-if="lastMessage?.supportId === null"
    @click="getGptResponse"
    :disabled="loading"
    :loading="gptResponseLoading"
    class="white--text mr-2"
    color="blue"
    depressed
    fab
    small
  >
    <v-icon>mdi-assistant</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'GetGptSuggestionButton',
  props: {
    lastMessage: {
      type: Object,
      required: false,
    },
    loading: Boolean,
  },

  computed: {
    gptResponseLoading() {
      return this.$store.state.gpt.loading;
    },
  },

  methods: {
    async getGptResponse() {
      if (!this.lastMessage) return;

      const { chatId, messageId } = this.lastMessage;

      await this.$store.dispatch('gpt/getGptResponse', {
        chatId,
        messageIds: [messageId],
      });
    },
  },
};
</script>
